// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"167":"7dfb1026c3aa3605","216":"a1b763e30b2ea122","263":"19cb63062b23591c"}[chunkId] + ".js";
};